export const BRANCHES_CHANGED_EVENT = "ZeitroBranchesChanged";

export function notifyBranchesChanged(detail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(BRANCHES_CHANGED_EVENT, { detail: detail || {} }));
}
